import { gql } from '@apollo/client';
import PRODUCT_FRAGMENT from './product';

const ORDER_ITEM_FRAGMENT = gql`
  fragment BaseOrderItem on OrderItem {
    id
    lineNumber
    licenseCount
    multiyearTerm
    siteLicenseRangeMin
    siteLicenseRangeMax
    dateCreated
    product {
      ...BaseProduct
    }
  }
  ${PRODUCT_FRAGMENT}
`;

export default ORDER_ITEM_FRAGMENT;
